/* eslint-disable no-unused-expressions,no-unused-vars */
// noinspection BadExpressionStatementJS

import debugFactory from "debug";
import { HocuspocusProvider } from "@hocuspocus/provider";
import { foundation } from "@teaming/slice-engine";
import { alertFactory } from "@teaming/common-ui";

export function getProvider( { documentName, ydoc, token, onSynced, translate, } ) {
	const debug = debugFactory( `teaming:hocuspocus:${ documentName }` );

	const { success, error, clean, } = alertFactory( "common-team.components.providerManager", translate );

	const handleStatus = ( () => {
		let isDisconnected = false;
		return status => {
			debug( { isDisconnected, status, } );
			if ( !isDisconnected && status === "disconnected" ) {
				isDisconnected = true;
				error( "noConnectionError", null, { duration: -1, ignoreDuplicates: true, group: "connectivity", } );
			}
			if ( isDisconnected && status === "connected" ) {
				isDisconnected = false;
				clean( { group: "connectivity", } );
				setImmediate( () => {
					success( "reconnectedMessage", null, { ignoreDuplicates: true, group: "connectivity", } );
				} );
			}
		};
	} )();

	// https://tiptap.dev/hocuspocus/provider/configuration
	return new HocuspocusProvider( {
		url: foundation().config.iceWebsocketUrl,
		name: documentName,
		document: ydoc,
		token,
		onSynced,
		onOpen() {
			false && debug( "OPEN" );
		},
		onConnect() {
			false && debug( "CONNECT" );
		},
		onAuthenticated() {
			debug( "AUTHENTICATED" );
		},
		onAuthenticationFailed: ( { reason, } ) => {
			debug( "AUTHENTICATION_FAILED", reason );
		},
		onStatus: ( { status, } ) => {
			debug( "STATUS", status );
			handleStatus( status );
		},
		onMessage: ( { event, message, } ) => {
			false && debug( "MESSAGE", message );
		},
		onOutgoingMessage: ( { message, } ) => {
			false && debug( "OUTGOING_MESSAGE", message );
		},
		onClose: ( { event, } ) => {
			debug( "CLOSE" );
			handleStatus( "disconnected" );
		},
		onDisconnect: ( { event, } ) => {
			debug( "DISCONNECT" );
		},
		onDestroy() {
			debug( "DESTROY" );
			clean( { group: "connectivity", } );
		},
		awarenessUpdate() {
			false && debug( "AWARENESS_UPDATE" );
		},
		awarenessChange() {
			false && debug( "AWANRESS_CHANGE" );
		},
	} );
}
